import axios from "axios";
import { Global } from "../../config/global";
import { changeEmpresa } from "../storage";

// onHandleLogin: Funcion para ejecutar el login y guardar datos dentro del local storage.

export const onHandleLogin = async ({ form }) => {
        try {
            let userLogin = form; //Guardar los datos del formulario en userLogin.
            const response = await axios.post(Global.url + 'auth/login', {
                username: userLogin.username,
                password: userLogin.password
            });
            console.log("RESPUESTA DEL LOGIN DESDE onHandleLogin", response);

            if (response.status === 200) {
                localStorage.setItem('userData', JSON.stringify(response.data));  //Guardar dentro del localStorage los datos del usuario logeado.
                let idEmpresaInicial = response.data.Empresas[0].IdEmpresa;  //Tomar por defecto el Id del primer elemento del array Empresas.
                changeEmpresa(idEmpresaInicial); //Extraer el array con los datos de la empresa en base al Id Empresa.
            }
            return response


        } catch (error) {
            console.log("error del el HANDLELOGIN,", error)
            return error
        }

};